<template>
  <modal @abort="closeModal" :closeable="false">
    <div class="success-container" v-if="currentMembership || requestedMembership">
      <div style="margin-top:30px;">
        <h3 v-html="successTitle" />
        <div>
          <template v-if="requestedMembership && requestedMembership">
            {{$t('messages.successfully_requested_text', {membership_type_name: requestedMembership.membershipType.name})}}
          </template>
          <template v-else>
            <div v-html="successMessage"/>
            <AddToWalletButton
              :plasticCard="currentMembership.plasticCard"
              message="Add your membership pass to your mobile wallet to access your membership card and benefits on the go."
              v-if="currentMembership && currentMembership.plasticCard"
            />
          </template>
<!--          <p>Success body dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod.-->
<!--          Dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod.</p>-->
        </div>
        <div class="footer">
          <div class="download">
<!--            <a>-->
<!--              <img src="../../assets/img/download.png"/>-->
<!--              Download receipt (PDF)-->
<!--            </a>-->
          </div>
          <div class="close-btn">
            <primary-button @click.prevent="closeModal" :disabled="false">
              {{$t('buttons.close')}}
            </primary-button>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <loading-indicator/>
    </div>
  </modal>
</template>

<script>
import PrimaryButton from '@/components/buttons/PrimaryButton.vue'
import Modal from '@/components/modal/ModalRegular.vue'
import LoadingIndicator from '@/components/global/LoadingIndicator.vue'
import AddToWalletButton from '@/components/membership/wallet/AddToWalletButton.vue'
import markdown from "markdown";

export default {
  computed: {
    successMessage() {
      const markdownText = this.$te(`messages.successfully_subscribed_text_${this.$appBranch}`) ? this.$t(`messages.successfully_subscribed_text_${this.$appBranch}`) :
        this.$t('messages.successfully_subscribed_text');
      return markdown.markdown.toHTML(markdownText);
    },
    successTitle() {
      const markdownText = this.$te(`messages.successfully_subscribed_title_${this.$appBranch}`) ? this.$t(`messages.successfully_subscribed_title_${this.$appBranch}`) :
        this.$t('titles.success');
      return markdown.markdown.toHTML(markdownText);
    },
    currentMembership() {
      return this.$store.getters.currentUser && this.$store.getters.currentUser.membership
    },
    requestedMembership() {
      return this.$store.getters.currentUser && this.$store.getters.currentUser.requestedMembership
    },
  },
  methods: {
    closeModal (){
      this.$router.push('/')
    }
  },
  components: {
    PrimaryButton,
    Modal,
    LoadingIndicator,
    AddToWalletButton,
  }
}
</script>

<style lang="scss" scoped>
.abort-wrapper-mob {
  display: none;
}
.success-container {
  h2 {
    // font-size: 1.5rem;
    color: $body-color;
  }
  img {
    margin-right: 10px;
  }
  p {
    font-family: $secondary-font-family;
    font-size: 1rem;
    color: $primary-btn-bg;
    }
  .footer {
    margin-top: 10px;
    div {
      padding: 30px 0;
    }
    a {
      font-family: $secondary-font-family;
      font-size: 1rem;
      color: $primary-btn-bg;
      text-decoration: underline;
      img {
        vertical-align: initial;
      }
      }
    .close-btn {
      text-align: right;
      @media screen and (max-width: 750px) {
        text-align: center;
      }
    }
  }
}
</style>


